import i18n from '../i18n';

/**
 * Plus Gold Notification Utility
 * Plus limitlerine takıldığında altın temalı bildirim gösterir
 */

/**
 * Plus Gold bildirimi gösterir
 * @param {string} feature - Özellik adı (Sohbet, Takvim, Dosya, Sesler, Temalar)
 * @param {string} message - Bildirim mesajı
 */
export function showPlusGoldNotification(feature, message) {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('notesplus-show-toast', {
      detail: {
        type: 'plus', // Özel Plus bildirimi tipi
        title: `[${feature}] ${message}`,
        message: i18n.t('shared:plusGoldNotification.removeLimits'),
        feature, // Hangi özellik için limit aşıldı
      },
    }));
  }
}

/**
 * Plus limit kontrolü için yardımcı fonksiyonlar
 */
export const PlusLimits = {
  CHAT_WINDOWS: 5, // Free kullanıcılar maksimum 5 aktif sohbet penceresi açabilir
  CALENDARS: 2, // Free kullanıcılar maksimum 2 takvim oluşturabilir (1 özel + 1 ekstra)
  FILE_SIZE_MB: 25, // Free kullanıcılar maksimum 25MB dosya gönderebilir
  PLUS_FILE_SIZE_MB: 100, // Plus kullanıcılar maksimum 100MB dosya gönderebilir
  // Grup limitleri
  GROUPS_CREATE: 1, // Free kullanıcılar maksimum 1 grup kurabilir
  GROUPS_JOIN: 2, // Free kullanıcılar maksimum 2 gruba katılabilir
};
